import { atom } from 'recoil';

export const emailAtom = atom({
  key: 'email',
  default: '',
});
